import Swiper from 'swiper/js/swiper';

export default class SwiperController {
    constructor() {

        this.sliders = document.querySelectorAll(".js-product-listing-slider");
        this.swiperScrollbar = document.querySelector('.swiper-scrollbar');

        if (this.sliders.length > 0 && this.swiperScrollbar) {
            this.init();
        }
    }


    init() {

        this.sliders.forEach(slider => {
            const swiper = new Swiper(slider, {

                // Optional parameters
                slidesPerView: '3.2',
                direction: 'horizontal',
                spaceBetween: 13,
                breakpoints: {
                    // when window width is >= 320px
                    320: {
                        slidesPerView: 1.2,
                        spaceBetween: 13
                    },
                    // when window width is >= 480px
                    480: {
                        slidesPerView: 2.2,
                        spaceBetween: 30
                    },
                    // when window width is >= 640px
                    1200: {
                        slidesPerView: 3.2,
                        spaceBetween: 40
                    }
                },
                loop: false,
                watchSlidesProgress: true,
                scrollbar: {
                    el: '.swiper-scrollbar',
                    draggable: true,
                },
            });

            swiper.on('progress', function (progress) {
                if (progress > 0) {
                    document.querySelector('.swiper-container').classList.add("scroll");
                } else {
                    document.querySelector('.swiper-container').classList.remove("scroll");

                }
            });

        });
    }
}








